import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../shared/components/Button";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import HttpService from "../../services/HttpService";
import {
	acceptedTerms,
	initialOnboarding,
	updateOnboardFieldRequest,
	validateInitialOnboarding,
} from "../../store/modules/register/actions";
import { recoverPasswordForPhoneSuccess } from "../../store/modules/recoverPassword/actions";
import { ButtonTerms, Container, Content, FormGroupInput, FormSubmit, Group, Label, Subtitle, Title } from "./styles";
import ZendeskChat from "../../components/ReactZenDeskChat";
import Phone from "../../components/welcome/phone";
import history from "../../services/history";
import { MessageError } from "../ChangePassword/styles";
import { validatingMaxBrazilianPhoneLength } from "../../utils";
import { onlyNumbers } from "../../utils";
import Recaptcha from "../../components/Recaptcha";

export default function OnboardNewAccount() {
	const { loading } = useSelector((state) => state.register);
	const dispatch = useDispatch();
	const [fullPhoneNumber, setFullPhoneNumber] = useState("");
	const [acceptTerms, setAcceptTerms] = useState(false);
	const [disabled, setDisabled] = useState(false);
	const [dataForm, setDataForm] = useState({});
	const [editable, setEditable] = useState(false);
	const [phoneInvalid, setPhoneInvalid] = useState("");
	const [isValidCaptcha, setIsValidCaptcha] = useState(false);
	const [tokenRecaptcha, setTokenRecaptcha] = useState(null);

	useEffect(() => {
		dispatch(acceptedTerms(acceptTerms));
		if (acceptTerms) {
			dispatch(updateOnboardFieldRequest("accept_term", acceptTerms, null));
		}

		isValidCaptcha ? setDisabled(true) : setDisabled(false);
	}, [acceptTerms, isValidCaptcha, dispatch]);

	const onboardAbandoned = (e) => {
		e.preventDefault();
		HttpService.setAbandonedOnboardStatus();
		sessionStorage.setItem("IS_ABANDONADED", true);
	};

	useEffect(() => {
		if (sessionStorage.getItem("IS_ABANDONADED") && !sessionStorage.getItem("GO_BACK"))
			history.push("/onboard/login");

		window.addEventListener("popstate", onboardAbandoned);
		window.addEventListener("beforeunload", onboardAbandoned);

		return () => {
			window.removeEventListener("beforeunload", onboardAbandoned);
			window.removeEventListener("popstate", onboardAbandoned);
			if (document.location.pathname === "/onboard/login") {
				HttpService.setAbandonedOnboardStatus();
				sessionStorage.setItem("IS_ABANDONADED", true);
			}
		};
	}, []);

	useEffect(() => {
		if (!sessionStorage.getItem("IS_ABANDONADED")) dispatch(initialOnboarding());
	}, [dispatch]);

	function sendPhone() {
		const newValue = fullPhoneNumber.replace(/\D/g, "");
		const cd_access_token = sessionStorage.getItem("cd_access_token");
		if (!Boolean(newValue)) {
			toast.error("Informe o seu número de celular para enviarmos o código de validação.");
			return;
		}
		dispatch(validateInitialOnboarding(cd_access_token, tokenRecaptcha));
	}

	function onPhoneChange(value) {
		const newValue = value.replace(/\D/g, "");
		setFullPhoneNumber(newValue);

		newValue.length > 10 ? setDisabled(true) : setDisabled(false);
	}

	const updateFieldPhone = (is_edition = false) => {
		const newValue = fullPhoneNumber.replace(/\D/g, "");
		if (newValue) {
			dispatch(updateOnboardFieldRequest("phone_number", newValue, null, is_edition));
			dispatch(recoverPasswordForPhoneSuccess(newValue));
			sessionStorage.setItem("vl_full_phone_number", newValue);
		}
	};

	return (
		<Container>
			<Content>
				<Title>Criar uma conta</Title>
				<Subtitle>Informe o seu número de celular para receber o código </Subtitle>
				<FormGroupInput>
					<Label>DDD + Número de celular</Label>
					<Phone
						numberPhone={fullPhoneNumber}
						onChange={(param) => {
							onPhoneChange(param);
							setPhoneInvalid(
								validatingMaxBrazilianPhoneLength(param)
							);
						}}
						onBlur={(param) => {
							if (
								onlyNumbers(param.target.value) !==
									dataForm.phoneNumber &&
								editable
							) {
								return updateFieldPhone(true);
							}
							updateFieldPhone();
						}}
						onFocus={(param) => {
							setDataForm({
								phoneNumber: onlyNumbers(
									param.target.value
								),
							});
							onlyNumbers(param.target.value).length > 2 &&
								setEditable(true);
						}}
						error={Boolean(phoneInvalid.length)}
					/>
					<MessageError>
						{Boolean(phoneInvalid.length) && phoneInvalid}
					</MessageError>
				</FormGroupInput>
				<Form>
					<Group>
						<input
							type="checkbox"
							name="remember"
							placeholder=" "
							checked={acceptTerms}
							onChange={() => setAcceptTerms(!acceptTerms)}
							className="checkbox-style"
						/>
						<span onClick={() => setAcceptTerms(!acceptTerms)}>
							Aceito os&nbsp;
							<ButtonTerms
								href={
									"https://trademap.com.br/termos-de-uso-e-politica-de-privacidade"
								}
								target="_blank"
							>
								Termos de Uso e Política de Privacidade
							</ButtonTerms>
						</span>
					</Group>

					<Recaptcha
						isValid={(param) => setIsValidCaptcha(param)}
						token={setTokenRecaptcha}
					/>

					<FormSubmit>
						<Button
							title="Enviar código"
							disabled={
								!acceptTerms ||
								!disabled ||
								Boolean(phoneInvalid.length)
							}
							onClick={() => sendPhone()}
							loading={loading}
						></Button>
					</FormSubmit>
				</Form>
			</Content>
			<ZendeskChat alwaysShow />
		</Container>
	);
}
